export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB"];
  let value = bytes / 1024;
  let unit = units[0];
  for (let index = 1; value >= 1024 && index < units.length; index += 1) {
    value /= 1024;
    unit = units[index];
  }
  return `${value.toFixed(value >= 10 ? 1 : 2)} ${unit}`;
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : "Something went wrong";
}

export function shareUrl(fileId: string, token: string): string {
  return `${window.location.origin}/d/${encodeURIComponent(fileId)}#${token}`;
}

export function saveShareToken(fileId: string, token: string): void {
  localStorage.setItem(`dropjet:share:${fileId}`, token);
}

export function getShareToken(fileId: string): string | null {
  return localStorage.getItem(`dropjet:share:${fileId}`);
}
